import { registerHandler } from '../paymentHandlerRegistry';

/**
 * Evertec payment handler.
 * Handle credit card and transfer payments through the Evertec engine.
 * Delegates execution to the useEvertecPayment hook via engineHooks.
 */
const evertecPaymentHandler = {
  canHandle: ({ selectedPaymentMethod }) => selectedPaymentMethod?.engine === 'evertec',

  execute: async ({ engineHooks }) => {
    await engineHooks.evertecPayment.executePayment();
  },
};

registerHandler('credit_card', evertecPaymentHandler);
registerHandler('transfer', evertecPaymentHandler);
